export default {
  settings: {
      twoStepVerification: "Bishimyorum-1",
      changePassword: "Bishimyorum-2",
      language: "Bishimyorum-3",
      details: "Details"
  }
};
